var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "table-responsive" }, [
        _c("table", [
          _c("thead", [
            _c("tr", [
              _c("th", [
                _c(
                  "button",
                  {
                    staticClass: "btn-success",
                    attrs: { disabled: _vm.disabled, type: "button" },
                    on: { click: _vm.agregarDetalle }
                  },
                  [_c("i", { staticClass: "fa fa-plus" })]
                )
              ]),
              _vm._v(" "),
              _c("th", [_vm._v("Destinatario")]),
              _vm._v(" "),
              _c("th", [_vm._v("Dirección")]),
              _vm._v(" "),
              _c("th", [_vm._v("Motivo de traslado")]),
              _vm._v(" "),
              _c("th", [_vm._v("Ruta")]),
              _vm._v(" "),
              _c("th", [_vm._v("# Documento")]),
              _vm._v(" "),
              _c("th")
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.modelValue, function(detalle, index) {
                return _c("tr", { key: index }, [
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "btn-info btn--text",
                        attrs: { disabled: _vm.disabled, type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.editarDetalle(index)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-edit" })]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      attrs: {
                        tooltip:
                          detalle.nombre_destinatario !== ""
                            ? detalle.nombre_destinatario
                            : "Seleccione..."
                      }
                    },
                    [_vm._v(_vm._s(detalle.nombre_destinatario))]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      attrs: {
                        tooltip:
                          detalle.direccion_destinatario !== ""
                            ? detalle.direccion_destinatario
                            : "Seleccione..."
                      }
                    },
                    [_vm._v(_vm._s(detalle.direccion_destinatario))]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      attrs: {
                        tooltip:
                          detalle.motivo_traslado !== ""
                            ? detalle.motivo_traslado
                            : "Seleccione..."
                      }
                    },
                    [_vm._v(_vm._s(detalle.motivo_traslado))]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      attrs: {
                        tooltip:
                          detalle.ruta !== "" ? detalle.ruta : "Seleccione..."
                      }
                    },
                    [_vm._v(_vm._s(detalle.ruta))]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      attrs: {
                        tooltip:
                          detalle.numero_documento !== ""
                            ? detalle.numero_documento
                            : "Seleccione..."
                      }
                    },
                    [_vm._v(_vm._s(detalle.numero_documento))]
                  ),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "btn-danger btn--text",
                        attrs: { disabled: _vm.disabled, type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.eliminarDetalle(index)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-trash" })]
                    )
                  ])
                ])
              }),
              _vm._v(" "),
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.modelValue.length === 0,
                      expression: "modelValue.length === 0"
                    }
                  ]
                },
                [_vm._m(0)]
              )
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            clickToClose: false,
            name: "detalleGuiaRemision",
            width: "70%",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("detalle-guia-remision", {
            attrs: { detallesActuales: _vm.modelValue },
            on: {
              personaActualizada: _vm.personaActualizada,
              cancelar: _vm.cancelarDetalle,
              input: _vm.inputDetalle
            },
            model: {
              value: _vm.selectedDetalle,
              callback: function($$v) {
                _vm.selectedDetalle = $$v
              },
              expression: "selectedDetalle"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "7" } }, [
      _c("strong", [_vm._v("No se ha agregado detalles.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a6487bc0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6487bc0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/TablaDetalleGuiaRemision.vue
// module id = 438
// module chunks = 0